import React, { useEffect, useRef } from "react";
import styled, { ThemeProvider } from "styled-components";
import { GlobalStyles, theme } from "../theme";
import { Navigation } from "./Navigation";
import { CookieProvider } from "./CookieProvider";
import { SITE_WIDTH_PX } from "../config";
import { CookieManagement } from "./CookieManagement";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const OverflowContainer = styled.div`
    width: 100vw;
    height: 100vh;
    overflow-x: hidden;
    // overflow-y: scroll; // enable when horizontal jumping is complained about
`;

const TopAnchor = styled.div.attrs({ id: "top", "aria-hidden": true })`
    visibility: hidden;
`;

const AppContainer = styled.div`
    max-width: ${SITE_WIDTH_PX};
    margin: 0 auto;
`;

const queryClient = new QueryClient();

export const Providers: React.FC<React.PropsWithChildren> = ({ children }) => {
    return (
        <ThemeProvider theme={theme}>
            <QueryClientProvider client={queryClient}>
                <>{children}</>
            </QueryClientProvider>
        </ThemeProvider>
    );
};

export const Layout: React.FC<
    React.PropsWithChildren<{ location: Location }>
> = ({ location, children }) => {
    const scrollContainerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!location.hash) {
            scrollContainerRef.current?.scrollTo(0, 0);
        }
    }, [location]);

    return (
        <CookieProvider>
            <OverflowContainer ref={scrollContainerRef}>
                <TopAnchor />
                <GlobalStyles />
                <AppContainer>
                    <Navigation location={location} />
                    <>{children}</>
                </AppContainer>
                <CookieManagement />
            </OverflowContainer>
        </CookieProvider>
    );
};
